export const DEFAULT_FACE_REACTS = { left_top: [0, 0], right_bottom: [0, 0] };
const initState = {
    originImage: '',
    faceRect: DEFAULT_FACE_REACTS,
    midTemplate: [],
    playType: [],
};
export const SET_ORIGIN_IMAGE = 'SET_ORIGIN_IMAGE';
export const SET_FACE_RECT = 'SET_FACE_RECT';
export const SET_MID_TEMPLATE = 'SET_MID_TEMPLATE';
export const SET_PLAY_TYPE = 'SET_PLAY_TYPE';
export const SET_SLIDE_MID = 'SET_SLIDE_MID';
export const SET_SLIDE_MID_QQ = 'SET_SLIDE_MID_QQ';
export const setOriginImage = (img) => ({
    type: SET_ORIGIN_IMAGE,
    payload: img,
});
export const setFaceRect = (faceRect) => ({
    type: SET_FACE_RECT,
    payload: faceRect,
});
export const setMidTemplate = (template) => ({
    type: SET_MID_TEMPLATE,
    payload: template
});
export const setPlayType = (type) => ({
    type: SET_PLAY_TYPE,
    payload: type
});
export const setSlideMid = (id) => ({
    type: SET_SLIDE_MID,
    payload: id,
});
export const setSlideMidQQ = (id) => ({
    type: SET_SLIDE_MID_QQ,
    payload: id,
});
const h5OlympicReducer = (state = initState, action) => {
    switch (action.type) {
        case SET_ORIGIN_IMAGE:
            return Object.assign(Object.assign({}, state), { originImage: action.payload });
        case SET_FACE_RECT:
            return Object.assign(Object.assign({}, state), { faceRect: action.payload });
        case SET_MID_TEMPLATE:
            return Object.assign(Object.assign({}, state), { midTemplate: action.payload });
        case SET_PLAY_TYPE:
            return Object.assign(Object.assign({}, state), { playType: action.payload.slice() });
        case SET_SLIDE_MID:
            return Object.assign(Object.assign({}, state), { slideMid: action.payload });
        case SET_SLIDE_MID_QQ:
            return Object.assign(Object.assign({}, state), { slideMidQQ: action.payload });
        default:
            return state;
    }
};
export default h5OlympicReducer;
